//* Vue
import type { ExtractPropTypes } from "vue";

export const DefaultSharePropsOption = {
    origin: { type: Object },
} as const;

export type DefaultShareProps = ExtractPropTypes<typeof DefaultSharePropsOption>;
